<div class="nd_sidebar-block">
  <!-- <div class="select-area flex-column" *ngIf="companyList.length != 0">
    <div class="d-flex align-items-center w-100">
      <div *ngIf="profile_image?.charAt(0) == '#'" [ngStyle]="{ 'background-color': profile_image }" class="avatar">
        {{ avatar }}
      </div>
      <div *ngIf="profile_image?.charAt(0) !== '#'">
        <img style="border-radius: 28%" alt="icon" draggable="false" width="50" height="50" src="{{ profile_image }}" />
      </div>
      <div class="select-field">
          <mat-select [panelClass]="'panel-A1class'" (selectionChange)="selectedValue($event.value)"
            [value]="selectedCompany">
            <mat-option *ngFor="let company of companyList" [value]="company.id" class="multiline-mat-option">
              {{ company.company_name | titlecase }}
            </mat-option>
          </mat-select>
          <img src="./assets/icons/select-icon.svg" alt="icon" draggable="false" />
        <p class="count-members">{{ checkMember() }}</p>
      </div>
    </div>
    <div class="divider-hr"></div>
  </div> -->

<div class="sidebar-block-new">
    <span *ngIf="profile_image?.charAt(0) == '#'" [ngStyle]="{ 'background-color': profile_image }" class="avatar-new">
      {{ avatar }}
    </span>
    <span *ngIf="profile_image?.charAt(0) !== '#'">
      <img style="border-radius: 28%" alt="icon" draggable="false" width="32" height="32" src="{{ profile_image }}" />
    </span>
    <span class="d-flex flex-column ms-2">
      <mat-select [panelClass]="'new-sidebar-company-selection'" (selectionChange)="selectedValue($event.value)"
        [value]="selectedCompany" appendTo="mat-select">
        <mat-option *ngFor="let company of companyList" [value]="company.id" class="multiline-mat-option">
          {{ company.company_name | titlecase }}
        </mat-option>
      </mat-select>
      <p class="count-member-new">{{ checkMember() }}</p>
    </span>
</div>  

  <ul class="sidebar-menu-section list-unstyled">
    <ng-container *ngFor="let submenu of sideMenu; let i = index">
      <li *ngIf="
          submenu.label !== 'HelpSection' &&
          submenu.label != 'Time sheet' &&
          submenu.label != 'Leave' &&
          submenu.label != 'Attendance'
        " (click)="submenu.label === 'Logout' ? authService.logout() : ''" (isActiveChange)="changeRoute($event)"
        [routerLink]="submenu.route" [routerLinkActive]="
          getPath().includes(submenu.label) ? 'active-link' : ''
        ">
        <a class="nav-link" [ngClass]="activeClass(submenu.route)">
          <img alt="icon" [src]="getImage(submenu.label)" draggable="false" />
          <label>{{ submenu.label }}</label>
        </a>
      </li>
      <li *ngIf="submenu.label == 'Time sheet' && timeLogData?.is_enabled"
        (click)="submenu.label === 'Logout' ? authService.logout() : ''" (isActiveChange)="changeRoute($event)"
        [routerLink]="submenu.route" [routerLinkActive]="
          getPath().includes(submenu.label) ? 'active-link' : ''
        ">
        <a class="nav-link" [ngClass]="activeClass(submenu.route)">
          <img alt="icon" [src]="getImage(submenu.label)" draggable="false" />
          <label>{{ submenu.label }}</label>
        </a>
      </li>

      <li *ngIf="
          submenu.label == 'Attendance' &&
          userAttendanceEligibility?.isAttendanceConfigEnabled &&
          (userAttendanceEligibility?.reportingToMemberPermission ||
            userAttendanceEligibility?.allMemberPermission ||
            userAttendanceEligibility?.isEligible)
        " (click)="submenu.label === 'Logout' ? authService.logout() : ''" (isActiveChange)="changeRoute($event)"
        [routerLink]="submenu.route" [routerLinkActive]="
          getPath().includes(submenu.label) ? 'active-link' : ''
        ">
        <a
        class="nav-link beta-parent-cls"
        [ngClass]="activeClass(submenu.route)"
      >
        <img alt="icon" [src]="getImage(submenu.label)" draggable="false"/>
        <label>{{ submenu.label }}</label>
      </a>
      </li>
      <li
        *ngIf="submenu.label == 'Leave' && userLeaveEligibility?.isHrmsEnabled && (userLeaveEligibility?.reportingToMemberPermission || userLeaveEligibility?.allMemberPermission || userLeaveEligibility?.isEligible)"
        (click)="submenu.label === 'Logout' ? authService.logout() : ''" (isActiveChange)="changeRoute($event)"
        [routerLink]="submenu.route" [routerLinkActive]="
        getPath().includes(submenu.label) ? 'active-link' : ''
      ">
        <a class="nav-link" [ngClass]="activeClass(submenu.route)">
          <img alt="icon" [src]="getImage(submenu.label)" draggable="false" />
          <label>{{ submenu.label }}</label>
        </a>
      </li>
      <li class="h-s-list d-none" *ngIf="submenu.label === 'HelpSection'">
        <a href="https://www.taskopad.com/terms-of-use/" style="text-decoration: none">
          <div class="help-section">
            <h2>Learn & Get Inspired</h2>
            <p class="help-desc">
              Dive right in and get started with the top must-have
            </p>
            <p class="help-start">LET’S START</p>
          </div>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
<!-- <ul class="sidebar-menu-section list-unstyled">
  <ng-container *ngFor="let submenu of sideMenu; let i = index">
    <li *ngIf="submenu.label !== 'HelpSection' && submenu.label != 'Time sheet' && submenu.label != 'Leave' && submenu.label != 'Attendance'"
      (click)="submenu.label === 'Logout' ? authService.logout() : ''" (isActiveChange)="changeRoute($event)"
      [routerLink]="submenu.route" [routerLinkActive]="
        getPath().includes(submenu.label) ? 'active-link' : ''
      ">
      <a class="nav-link" [ngClass]="activeClass(submenu.route)">
        <img alt="icon" [src]="getImage(submenu.label)" draggable="false" />
        <label>{{ submenu.label }}</label>
      </a>
    </li>
    <li *ngIf="submenu.label == 'Time sheet' && timeLogData?.is_enabled"
      (click)="submenu.label === 'Logout' ? authService.logout() : ''" (isActiveChange)="changeRoute($event)"
      [routerLink]="submenu.route" [routerLinkActive]="
        getPath().includes(submenu.label) ? 'active-link' : ''
      ">
      <a class="nav-link" [ngClass]="activeClass(submenu.route)">
        <img alt="icon" [src]="getImage(submenu.label)" draggable="false" />
        <label>{{ submenu.label }}</label>
      </a>
    </li>

    <li *ngIf="submenu.label == 'Leave' && userLeaveEligibility?.isHrmsEnabled && (userLeaveEligibility?.reportingToMemberPermission || userLeaveEligibility?.allMemberPermission || userLeaveEligibility?.isEligible)"
      (click)="submenu.label === 'Logout' ? authService.logout() : ''" (isActiveChange)="changeRoute($event)"
      [routerLink]="submenu.route" [routerLinkActive]="
        getPath().includes(submenu.label) ? 'active-link' : ''
      ">
      <a class="nav-link" [ngClass]="activeClass(submenu.route)">
        <img alt="icon" [src]="getImage(submenu.label)" draggable="false" />
        <label>{{ submenu.label }}</label>
      </a>
    </li>

    <li *ngIf="submenu.label == 'Attendance' && userAttendanceEligibility?.isAttendanceConfigEnabled && (userAttendanceEligibility?.reportingToMemberPermission || userAttendanceEligibility?.allMemberPermission || userAttendanceEligibility?.isEligible)"
      (click)="submenu.label === 'Logout' ? authService.logout() : ''" (isActiveChange)="changeRoute($event)"
      [routerLink]="submenu.route" [routerLinkActive]="
        getPath().includes(submenu.label) ? 'active-link' : ''
      ">
      <a class="nav-link" [ngClass]="activeClass(submenu.route)">
        <img alt="icon" [src]="getImage(submenu.label)" draggable="false" />
        <label>{{ submenu.label }}</label>
      </a>
    </li>


    <li class="h-s-list d-none" *ngIf="submenu.label === 'HelpSection'">
      <a href="https://www.taskopad.com/terms-of-use/" style="text-decoration: none">
        <div class="help-section">
          <h2>Learn & Get Inspired</h2>
          <p class="help-desc">
            Dive right in and get started with the top must-have
          </p>
          <p class="help-start">LET’S START</p>
        </div>
      </a>
    </li>
  </ng-container>
</ul> -->